import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  rowWrapper: {
    width: '100%',
    borderStyle: 'solid',
    borderWidth: '0 1px 1px 0',
  },
  priceListItemContainer: {
    padding: theme.spacing(1.5, 2.5),
    borderStyle: 'solid',
    borderWidth: '1px 0 0 1px',
    '&:first-child p': {
      fontWeight: 500,
    },
  },
}))
